import { boolean, object, string } from "yup"

export const contactsValidation = object({
    name: string().required(),
    email: string().email().required(),
    telegram: string().required(),
    privacy_policy: boolean()
        .oneOf([true])
        .required()
})